import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { ToolHolder } from "@interfaces/models/toolHolder.interface";
import { ToolHolderMachine } from "@interfaces/models/toolHolderMachine.interface";
import { MachineService } from "@services/machine.service";
import { ToolHolderService } from "@services/toolHolder.service";
import { ToolHolderMachineService } from "@services/toolHolderMachine.service";
import { ToastService } from "angular-toastify";
import { ToastApiError } from "@helpers/apiError";

@Component({
	moduleId: module.id,
	selector: "toolHolders-id",
	styleUrls: ["toolHolders-id.css"],
	templateUrl: "toolHolders-id.html"
})
export class ToolHoldersIdAdminComponent {
	activeMachineIds: number[] = [];
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	item: ToolHolder = new ToolHolder();
	itemType = "Tool Holder";
	machines: Machine[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;
	toolHolderMachines: ToolHolderMachine[] = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: ToolHolderService, private machineService: MachineService, private toolHolderMachineService: ToolHolderMachineService) {
		this.buildButtons("view");
		this.getMachines();
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				(res: any) => {
					const filteredMachines = this.machines.filter((f) => this.activeMachineIds.indexOf(f.id) !== -1);
					this.toolHolderMachineService.updateMachinesForToolHolder(res.response.lookupId, filteredMachines)
						.subscribe(
							() => this.toastService.success("Successfully Linked Machines"),
							(err) => { console.log(err); ToastApiError(this.toastService, err); }
						);
					this.toastService.success("Successfully Created " + this.itemType);
					this.item = new ToolHolder();
					this.close();
				},
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getToolHolderLinks();
				},
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => this.machines = res.response.items,
				(err) => console.log(err)
			);
	}

	getToolHolderLinks() {
		this.toolHolderMachineService.forToolHolder(this.item.id)
			.subscribe(
				(res: any) => this.toolHolderMachines = res.response,
				(err) => console.log(err),
				() => this.toolHolderMachines.forEach((w) => this.activeMachineIds.push(w.machineId))
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	toggleMachine(machine: Machine) {
		if (this.readOnly) return;
		const index = this.activeMachineIds.indexOf(machine.id);
		if (index === -1) this.activeMachineIds.push(machine.id);
		else this.activeMachineIds.splice(index, 1);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					const filteredMachines = this.machines.filter((f) => this.activeMachineIds.indexOf(f.id) !== -1);
					this.toolHolderMachineService.updateMachinesForToolHolder(this.item.lookupId, filteredMachines)
						.subscribe(
							() => this.toastService.success("Successfully Updated"),
							(err) => { console.log(err); ToastApiError(this.toastService, err); }
						);
				},
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}
}
